import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync } from "@fortawesome/free-solid-svg-icons"
import { useSelector } from "react-redux"
import { formatNumber } from "../../utilities/Addons"
import { URL } from "../../store/actions/depannageActions"
import CustomModal from "../basics/interface/CustomModal"
import { COLORS } from "../../utilities/Constants"

// Ligne label → valeur (alignée à droite, tabular-nums). `strong` met le total
// en avant. Réutilisée par Totaux et Marge.
export const StatRow = ({ label, value, unit = "CHF", strong = false }) => (
	<div
		style={{
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			gap: 16,
			padding: "9px 2px",
			borderBottom: `1px solid ${COLORS.border}`,
		}}
	>
		<span
			style={{
				fontSize: 14,
				fontWeight: strong ? 600 : 500,
				color: strong ? COLORS.text : COLORS.textMuted,
			}}
		>
			{label}
		</span>
		<span style={{ display: "inline-flex", alignItems: "baseline", gap: 6 }}>
			<span
				style={{
					fontSize: strong ? 17 : 15,
					fontWeight: strong ? 700 : 600,
					color: COLORS.text,
					fontVariantNumeric: "tabular-nums",
				}}
			>
				{value}
			</span>
			<span style={{ fontSize: 11, color: COLORS.textLight, width: 38 }}>
				{unit}
			</span>
		</span>
	</div>
)

const AtelierSearchTotal = ({ visible, closeModal, ateliers }) => {
	const { token } = useSelector((state) => state.navInfo.login)
	const { employes: depanneurs } = useSelector((state) => state.masterReducer)
	const [state, setState] = useState({
		fTot: 0.0,
		moTot: 0.0,
		aTot: 0.0,
		tot: 0.0,
		emps: [],
		loading: true,
	})

	const getValues = async () => {
		const ids = ateliers.map((a) => a.id).join(",")
		const res = await fetch(`${URL}api/atelier-search-view?ids=${ids}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
		return await res.json()
	}

	useEffect(() => {
		const run = async () => {
			try {
				const data = await getValues()
				const emps = []
				for (let [key, value] of Object.entries(data.heures)) {
					const hTot = formatNumber(Math.round(100 * value) / 100)
					if (key !== "null") {
						const empId = parseInt(key)
						const dep = depanneurs.find((d) => d.id === empId)
						emps.push({ nom: dep ? dep.nom : `#${empId}`, hTot })
					} else {
						emps.push({ nom: "Non associé", hTot })
					}
				}
				setState({
					moTot: formatNumber(Math.round(20 * data.tot_mo_ttc) / 20),
					fTot: formatNumber(Math.round(20 * data.tot_fo_ttc) / 20),
					aTot: formatNumber(Math.round(20 * data.tot_autre_ttc) / 20),
					tot: formatNumber(Math.round(20 * data.tot_ttc) / 20),
					emps,
					loading: false,
				})
			} catch (e) {
				setState((s) => ({ ...s, loading: false }))
			}
		}
		run()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	if (!visible) return null

	return (
		<CustomModal
			title="Totaux"
			onClose={closeModal}
			showFooter={false}
			maxWidth={460}
		>
			{state.loading ? (
				<div style={{ display: "flex", justifyContent: "center", padding: 28 }}>
					<FontAwesomeIcon
						icon={faSync}
						spin
						style={{ color: COLORS.textLight, fontSize: 20 }}
					/>
				</div>
			) : (
				<div>
					<StatRow label="Fournitures" value={state.fTot} />
					<StatRow label="Main d'œuvre" value={state.moTot} />
					<StatRow label="Autres" value={state.aTot} />
					<StatRow label="Total" value={state.tot} strong />
					{state.emps.length > 0 && (
						<div
							style={{
								marginTop: 18,
								marginBottom: 6,
								fontSize: 11,
								fontWeight: 600,
								letterSpacing: "0.08em",
								textTransform: "uppercase",
								color: COLORS.textLight,
							}}
						>
							Heures par mécanicien
						</div>
					)}
					{state.emps.map((emp) => (
						<StatRow
							key={`emp_${emp.nom}`}
							label={emp.nom}
							value={emp.hTot}
							unit="Heures"
						/>
					))}
				</div>
			)}
		</CustomModal>
	)
}

export default AtelierSearchTotal
